export function toggle_loader() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  //check to see if we have an installer loader on this page (unless type is set to default)
  var installers_loader = type != 'default' ? document.getElementById('installers-loader') : false;

  if (installers_loader) {
    //check to see if we have a progress bar
    var progress_bar = document.querySelector('#installers-loader .loading-bar .progress'); //if we have a progress bar

    if (progress_bar) {
      //reset the width
      progress_bar.style.width = '0%';
    }
  }

  document.body.classList.add(installers_loader ? 'installers-loading' : 'loading'); //if this isn't the installers loader

  if (!installers_loader) {
    //set a timeout to disable the loader after 15 seconds
    setTimeout(function () {
      disable_loader();
    }, 15000);
  }
}
export function disable_loader() {
  document.body.classList.remove('loading'); //if this contains the installers loading class

  if (document.body.classList.contains('installers-loading')) {
    //check to see if we have a progress bar
    var progress_bar = document.querySelector('#installers-loader .loading-bar .progress'); //if we have a progress bar

    if (progress_bar) {
      //set the width to full
      progress_bar.style.width = '100%'; //wait for the animation to finish

      setTimeout(function () {
        //remove the loading class
        document.body.classList.remove('installers-loading');
      }, 1000);
    } else {
      //if we don't have a progress bar, we can just remove the loading class instantly
      document.body.classList.remove('installers-loading');
    }
  }
}